webpackJsonp([7],{

/***/ 104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = canUseDOM;
/* harmony export (immutable) */ __webpack_exports__["g"] = isProductionEnvironment;
/* harmony export (immutable) */ __webpack_exports__["f"] = isIframeEnvironment;
/* harmony export (immutable) */ __webpack_exports__["c"] = isDesktopApp;
/* harmony export (immutable) */ __webpack_exports__["h"] = isReleased;
/* harmony export (immutable) */ __webpack_exports__["d"] = isEmbedApp;
/* harmony export (immutable) */ __webpack_exports__["e"] = isGamedistributionApp;
/* harmony export (immutable) */ __webpack_exports__["b"] = getParams;
/* harmony export (immutable) */ __webpack_exports__["i"] = mailTo;
/* unused harmony export sentryTrackAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_semver__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_semver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dom_to_image__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dom_to_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_dom_to_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid_v1__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid_v1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uuid_v1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lzbase62__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lzbase62___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lzbase62__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}

function isProductionEnvironment() {
  // // HACK: For development purposes
  // if (canUseDOM && is.equal(process.env.NODE_ENV, 'development')) {
  //   return true;
  // }

  // Return true if production
  if (is.equal("production", "production")) {
    return true;
  }

  // Return false
  return false;
}

function isIframeEnvironment() {
  // // HACK: For development purposes
  // if (canUseDOM && is.equal(process.env.NODE_ENV, 'development')) {
  //   return true;
  // }

  // Return false if desktop and unreleased version
  if (canUseDOM && window.location !== window.parent.location) {
    return true;
  }

  // Return false
  return false;
}

function isDesktopApp() {
  // // HACK: For development purposes
  // if (canUseDOM && is.equal(process.env.NODE_ENV, 'development')) {
  //   return true;
  // }

  // Return false if desktop and unreleased version
  if (is.equal(queryParameters.platform, "desktop")) {
    return true;
  }

  // Return false
  return false;
}

function isReleased() {
  // // HACK: For development purposes
  // if (canUseDOM && is.equal(process.env.NODE_ENV, 'development')) {
  //   return true;
  // }

  // Set if is released or not
  var isReleased = false;
  //
  // // Return false if unreleased
  // if (
  //   is.equal(queryParameters.platform, "desktop") &&
  //   is.existy(queryParameters.version) &&
  //   semver.eq(queryParameters.version, "1.0.8") &&
  //   is.falsy(isReleased)
  // ) {
  return false;
  // }

  // Return true
  return true;
}

function isEmbedApp() {
  // // HACK: For development purposes
  // if (canUseDOM && is.equal(process.env.NODE_ENV, 'development')) {
  //   return true;
  // }

  // Return false if desktop and unreleased version
  if (global.queryParameters.platform == "embed") {
    return true;
  }

  // Return false
  return false;
}

function isGamedistributionApp() {
  // // HACK: For development purposes
  // if (canUseDOM && is.equal(process.env.NODE_ENV, 'development')) {
  //   return true;
  // }

  // Return false if desktop and unreleased version
  if (global.queryParameters.platform == "gamedistribution") {
    return true;
  }

  // Return false
  return false;
}

function getParams(query) {
  if (!query) {
    return {};
  }

  return (/^[?#]/.test(query) ? query.slice(1) : query).split("&").reduce(function (params, param) {
    var _param$split = param.split("="),
        _param$split2 = _slicedToArray(_param$split, 2),
        key = _param$split2[0],
        value = _param$split2[1];

    return Object.assign(params, _defineProperty({}, key, value ? decodeURIComponent(value.replace(/\+/g, " ")) : ""));
  }, {});
}

function mailTo() {
  $.notify("Opening email... hang on.");

  var openEmail = function openEmail(imageURL) {
    var body = '\n      %0D%0A\n      %0D%0A\n      ------\n      %0D%0A%0D%0A\n      When%20reporting%20a%20bug,%20please%20describe%20the%20bug%20as%20clearly%20as%20possible.\n      %0D%0A%0D%0A\n      Game:%20' + global.game + '\n      %0D%0A%0D%0A\n      Platform:%20' + window.queryParameters.platform + '\n      %0D%0A%0D%0A\n      Version:%20' + window.queryParameters.version + '\n      %0D%0A%0D%0A\n      ID:%20' + firebase.auth().currentUser.uid + '\n      %0D%0A%0D%0A\n      Screenshot:%20' + imageURL + '\n      %0D%0A%0D%0A\n      Device:%20' + global.bowser.osname + '%20' + global.bowser.osversion + '\n      %0D%0A%0D%0A\n      Browser:%20' + global.bowser.name + '%20' + global.bowser.version + '\n    ';

    window.location.href = 'mailto:contact@online-jigsaw-puzzles.com?subject=Jigsaw%20Puzzle%20feedback%20(' + global.game + ')&body=' + body;

    Raven.captureMessage('Email has been opened', {
      level: 'error',
      tags: {
        game: global.game,
        uid: firebase.auth().currentUser.uid
      }
    });
  };

  if (canUseDOM()) {
    __WEBPACK_IMPORTED_MODULE_1_dom_to_image___default.a.toJpeg(document.getElementById('game_container'), {
      quality: 0.50,
      bgcolor: "#EBEBEB",
      filter: function filter(node) {
        return is.not.equal(node.id, "p_2104993");
      }
    }).then(function (dataUrl) {
      firebase.storage().ref().child('screenshots/' + global.game + '_' + __WEBPACK_IMPORTED_MODULE_2_uuid_v1___default()() + '.jpg').putString(dataUrl, 'data_url').then(function (snapshot) {
        snapshot.ref.getDownloadURL().then(function (downloadURL) {
          openEmail(encodeURIComponent(downloadURL));
        });
      }).catch(function (error) {
        openEmail("Not available");
      });;
    }).catch(function (error) {
      openEmail("Not available");
    });
  }
}

var sentryMessageSent = false;
function sentryTrackAction(action) {
  Raven.captureBreadcrumb({
    message: action,
    category: 'action'
  });
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(15)))

/***/ }),

/***/ 153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = assetPath;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_res__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_res___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_res__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_ExecutionEnvironment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_ExecutionEnvironment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_ExecutionEnvironment__);



var imageRequest = __webpack_require__(590);
var svgRequest = __webpack_require__(713);
var soundRequest = __webpack_require__(715);

function assetPath(assetName) {
  var assetExtension = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "jpg";

  // Create path
  var path = null;
  var privateResolution = 2;

  // Set resolution if possible
  if (__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_ExecutionEnvironment__["canUseDOM"]) {
    privateResolution = _.min([_.toInteger(__WEBPACK_IMPORTED_MODULE_0_res___default.a.dppx()), 3]);
    privateResolution = _.max([privateResolution, 1]);
  }

  // Return correct path
  if (is.equal(assetExtension, "jpg") || is.equal(assetExtension, "jpeg") || is.equal(assetExtension, "png")) {
    path = imageRequest("./" + assetName + "@" + privateResolution + "x." + assetExtension);
  }

  // Return correct path
  if (is.equal(assetExtension, "svg")) {
    path = svgRequest("./" + assetName + "." + assetExtension);
  }

  // Return correct path
  if (is.equal(assetExtension, "aif") || is.equal(assetExtension, "mp3")) {
    path = soundRequest("./" + assetName + "." + assetExtension);
  }

  // Return path
  return path;
}

/***/ }),

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = getCookie;
/* harmony export (immutable) */ __webpack_exports__["b"] = saveCookie;
/* unused harmony export removeCookie */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__misc__ = __webpack_require__(104);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };






if (Object(__WEBPACK_IMPORTED_MODULE_2__misc__["a" /* canUseDOM */])()) {
  __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.defaults = {
    expires: 365 * 10
  };

  // HOTFIX: To fix cookies not working on iPhones
  window.sessionCookies = {};
}

function getCookie(name) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var isJSON = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  // Return correct value if client
  if (Object(__WEBPACK_IMPORTED_MODULE_2__misc__["a" /* canUseDOM */])()) {
    // Set default value if not set
    if (is.not.undefined(defaultValue) && is.undefined(__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(name)) && is.undefined(window.sessionCookies[name])) {
      __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(name, defaultValue, Object.assign({}, __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.defaults, Object(__WEBPACK_IMPORTED_MODULE_2__misc__["f" /* isIframeEnvironment */])() && global.parser.getBrowser().name != "Safari" ? { SameSite: 'None', Secure: true } : {}));
      window.sessionCookies[name] = defaultValue;
    }

    // Return cookie value
    if (isJSON) {
      if (is.undefined(__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(name))) JSON.parse(window.sessionCookies[name]);
      return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.getJSON(name);
    }

    // Get correct value
    var value = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(name);

    if (is.undefined(value)) {
      value = window.sessionCookies[name];
      if (value == "true") value = true;
      if (value == "false") value = false;
    }

    // Change to number if necessary
    if (/^\d*(\.\d+)?$/.test(value)) {
      value = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["toNumber"])(value);
    }

    // Change to boolean if necessary
    if (is.equal(value, "true") || is.equal(value, "false")) {
      value = is.equal(value, "true");
    }

    if (value === null || value === undefined) value = defaultValue;

    // return value
    return value;
  }

  // Return value
  return defaultValue;
}

function saveCookie(name, value, options) {
  // Return correct value if client
  if (Object(__WEBPACK_IMPORTED_MODULE_2__misc__["a" /* canUseDOM */])()) {
    // Set value
    if ((typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object') {
      __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(name, "" + JSON.stringify(value), Object.assign({}, __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.defaults, Object(__WEBPACK_IMPORTED_MODULE_2__misc__["f" /* isIframeEnvironment */])() && global.parser.getBrowser().name != "Safari" ? { SameSite: 'None', Secure: true } : {}, options));
      window.sessionCookies[name] = "" + JSON.stringify(value);
    } else {
      __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(name, "" + value, Object.assign({}, __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.defaults, Object(__WEBPACK_IMPORTED_MODULE_2__misc__["f" /* isIframeEnvironment */])() && global.parser.getBrowser().name != "Safari" ? { SameSite: 'None', Secure: true } : {}, options));
      window.sessionCookies[name] = "" + value;
    }
  }

  // Return value
  return value;
}

function removeCookie(name) {
  // Return correct value if client
  if (Object(__WEBPACK_IMPORTED_MODULE_2__misc__["a" /* canUseDOM */])()) {
    // Set value
    __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove(name);
  }
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(15)))

/***/ }),

/***/ 232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__);


// Navigation manager, e.g. history.push('/home')
// https://github.com/mjackson/history
/* harmony default export */ __webpack_exports__["a"] = (true && __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default()());

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/play@2x.png?71e40f90";

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/table_yes.svg?39316185";

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/list_check.svg?23f5ef75";

/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/table_no.svg?d5021999";

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(243);
module.exports = __webpack_require__(445);


/***/ }),

/***/ 445:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/whatwg-fetch/fetch.js
var whatwg_fetch_fetch = __webpack_require__(446);
var fetch_default = /*#__PURE__*/__webpack_require__.n(whatwg_fetch_fetch);

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(81);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(231);
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./node_modules/react-deep-force-update/lib/index.js
var lib = __webpack_require__(538);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(539);
var query_string_default = /*#__PURE__*/__webpack_require__.n(query_string);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(154);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./node_modules/is_js/is.js
var is_js_is = __webpack_require__(234);
var is_default = /*#__PURE__*/__webpack_require__.n(is_js_is);

// EXTERNAL MODULE: ./node_modules/mitt/dist/mitt.es.js
var mitt_es = __webpack_require__(542);

// EXTERNAL MODULE: ./node_modules/bootstrap-breakpoints/src/bootstrap-breakpoints.js
var bootstrap_breakpoints = __webpack_require__(543);
var bootstrap_breakpoints_default = /*#__PURE__*/__webpack_require__.n(bootstrap_breakpoints);

// EXTERNAL MODULE: ./node_modules/ua-parser-js/src/ua-parser.js
var ua_parser = __webpack_require__(544);
var ua_parser_default = /*#__PURE__*/__webpack_require__.n(ua_parser);

// EXTERNAL MODULE: ./node_modules/bowser/src/bowser.js
var src_bowser = __webpack_require__(545);
var bowser_default = /*#__PURE__*/__webpack_require__.n(src_bowser);

// CONCATENATED MODULE: ./src/utils/createFetch.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * Creates a wrapper function around the HTML5 Fetch API that provides
 * default arguments to fetch(...) and is intended to reduce the amount
 * of boilerplate code in the application.
 * https://developer.mozilla.org/docs/Web/API/Fetch_API/Using_Fetch
 */
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

function createFetch(fetch, _ref) {
  var _this = this;

  var baseUrl = _ref.baseUrl,
      cookie = _ref.cookie;

  // NOTE: Tweak the default options to suite your application needs
  var defaults = {
    method: 'GET',
    mode: baseUrl ? 'cors' : 'same-origin',
    credentials: baseUrl ? 'include' : 'same-origin',
    headers: _extends({
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }, cookie ? { Cookie: cookie } : null)
  };

  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url, options) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', url.startsWith('/api') ? fetch('' + baseUrl + url, _extends({}, defaults, options, {
                headers: _extends({}, defaults.headers, options && options.headers)
              })) : fetch(url, options));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
}

/* harmony default export */ var utils_createFetch = (createFetch);
// EXTERNAL MODULE: ./node_modules/mixpanel-browser/dist/mixpanel.cjs.js
var mixpanel_cjs = __webpack_require__(547);
var mixpanel_cjs_default = /*#__PURE__*/__webpack_require__.n(mixpanel_cjs);

// EXTERNAL MODULE: ./node_modules/raven-js/src/singleton.js
var singleton = __webpack_require__(548);
var singleton_default = /*#__PURE__*/__webpack_require__.n(singleton);

// EXTERNAL MODULE: ./node_modules/soundmanager2/script/soundmanager2.js
var soundmanager2 = __webpack_require__(554);
var soundmanager2_default = /*#__PURE__*/__webpack_require__.n(soundmanager2);

// EXTERNAL MODULE: ./node_modules/current-device/es/index.js
var es = __webpack_require__(555);

// EXTERNAL MODULE: ./node_modules/@firebase/app/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(102);

// EXTERNAL MODULE: ./node_modules/@firebase/auth/dist/auth.js
var auth = __webpack_require__(556);
var auth_default = /*#__PURE__*/__webpack_require__.n(auth);

// EXTERNAL MODULE: ./node_modules/@firebase/database/dist/index.cjs.js
var index_cjs = __webpack_require__(557);
var index_cjs_default = /*#__PURE__*/__webpack_require__.n(index_cjs);

// EXTERNAL MODULE: ./node_modules/@firebase/storage/dist/index.esm.js
var dist_index_esm = __webpack_require__(559);

// EXTERNAL MODULE: ./node_modules/lazysizes/lazysizes.js
var lazysizes = __webpack_require__(562);
var lazysizes_default = /*#__PURE__*/__webpack_require__.n(lazysizes);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(103);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var react_redux_es = __webpack_require__(233);

// EXTERNAL MODULE: ./src/utils/misc.js
var misc = __webpack_require__(104);

// EXTERNAL MODULE: ./src/utils/cookie.js
var cookie = __webpack_require__(230);

// CONCATENATED MODULE: ./src/components/App.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var App__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ContextType = App__extends({
  // Enables critical path CSS rendering
  // https://github.com/kriasoft/isomorphic-style-loader
  insertCss: prop_types_default.a.func.isRequired
}, react_redux_es["a" /* Provider */].childContextTypes, {
  // Universal HTTP client
  fetch: prop_types_default.a.func.isRequired,
  pathname: prop_types_default.a.string.isRequired,
  query: prop_types_default.a.object
});

/**
 * The top-level React component setting context (global) variables
 * that can be accessed from all the child components.
 *
 * https://facebook.github.io/react/docs/context.html
 *
 * Usage example:
 *
 *   const context = {
 *     history: createBrowserHistory(),
 *     store: createStore(),
 *   };
 *
 *   ReactDOM.render(
 *     <App context={context}>
 *       <LayoutComponent>
 *         <LandingPage />
 *       </LayoutComponent>
 *     </App>,
 *     container,
 *   );
 */

var App_App = function (_React$PureComponent) {
  _inherits(App, _React$PureComponent);

  function App() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, App);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = App.__proto__ || Object.getPrototypeOf(App)).call.apply(_ref, [this].concat(args))), _this), _this.darkModeChanged = function (mode) {
      // Show message
      if (is.equal(mode, "dark")) {
        $("body").attr("data-mode", "dark");
      } else {
        $("body").attr("data-mode", "light");
      }
    }, _this.purchaseProductInitiated = function (type) {
      // Show message
      if (is.equal(type, "restore")) {
        $.notify("Initiating restore... hang on.");
      } else {
        $.notify("Initiating purchase... hang on.");
      }
    }, _this.purchaseProductAppleServerError = function (type) {
      // Show message
      if (is.equal(type, "restore")) {
        $.notify("Restore could not start. There's a problem with Apple's servers.");
      } else {
        $.notify("Purchase could not start. There's a problem with Apple's servers.");
      }
    }, _this.purchaseProductPurchasing = function (type) {
      // Show message
      if (is.equal(type, "restore")) {
        $.notify("Restore started... hang on.");
      } else {
        $.notify("Purchase started... hang on.");
      }
    }, _this.purchaseProductSuccessful = function (type) {
      // Show message
      $.notify("Purchase was successful... hang on.");

      // Save as purchased
      Object(cookie["b" /* saveCookie */])("purchasedUnlimitedGames", true);

      // Reload website
      setTimeout(function () {
        window.location.reload(false);
      }, 3000);
    }, _this.purchaseProductError = function (type) {
      // Show message
      $.notify("Purchase didn't go through. An error occurred.");
    }, _this.purchaseProductRestored = function (type) {
      // Show message
      $.notify("Restoring purchase was successful... hang on.");

      // Save as purchased
      Object(cookie["b" /* saveCookie */])("purchasedUnlimitedGames", true);

      // Reload website
      setTimeout(function () {
        window.location.reload(false);
      }, 3000);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(App, [{
    key: "getChildContext",
    value: function getChildContext() {
      return this.props.context;
    }

    //-----------------------------------------------------------------------
    // Lifecycle
    //-----------------------------------------------------------------------

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // Add type of device as class
      if (is.truthy(bowser.mobile)) {
        $("body").addClass("mobile");
      } else if (is.truthy(bowser.tablet)) {
        $("body").addClass("tablet");
      } else {
        $("body").addClass("desktop");
      }

      // Listen for Electron action taps
      if (Object(misc["c" /* isDesktopApp */])() && is.existy(window.electron)) {
        window.electron.onMessageFromRendererToWebview(function (params) {
          // On purchase clicked
          if (is.equal(params.action, "purchase_unlimited_games") || is.equal(params.action, "purchase_restore_purchase")) {
            // Purchase product
            window.electron.purchaseProduct(window.queryParameters.purchase_id);
          } else if (is.equal(params.action, "dark_mode_changed")) {
            _this2.darkModeChanged(params.value);
          }
        });

        // Listen for purchase events
        emitter.on("purchase_product_initiated", this.purchaseProductInitiated);
        emitter.on("purchase_product_apple_server_error", this.purchaseProductAppleServerError);
        emitter.on("purchase_product_purchasing", this.purchaseProductPurchasing);
        emitter.on("purchase_product_successful", this.purchaseProductSuccessful);
        emitter.on("purchase_product_error", this.purchaseProductError);
        emitter.on("purchase_product_restored", this.purchaseProductRestored);
      }
    }

    //-----------------------------------------------------------------------
    // Handlers
    //-----------------------------------------------------------------------

  }, {
    key: "render",


    //-----------------------------------------------------------------------
    // Render
    //-----------------------------------------------------------------------
    value: function render() {
      // NOTE: If you need to add or modify header, footer etc. of the app,
      // please do that inside the Layout component.
      return react_default.a.Children.only(this.props.children);
    }
  }]);

  return App;
}(react_default.a.PureComponent);

App_App.childContextTypes = ContextType;


/* harmony default export */ var components_App = (App_App);
// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 15 modules
var redux_es = __webpack_require__(228);

// EXTERNAL MODULE: ./node_modules/redux-thunk/es/index.js
var redux_thunk_es = __webpack_require__(576);

// CONCATENATED MODULE: ./src/constants/index.js
// Initial state
var INITIAL_STATE = {
  isGameActive: false,
  isGameAnimating: false,
  startTime: new Date(),
  isEdgesActive: false,
  isPreviewActive: false
};


// CONCATENATED MODULE: ./src/reducer/index.js


var reducer_reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments[1];

  switch (action.type) {
    case "START_NEW_GAME":
      {
        // Initial variables
        var newState = _.cloneDeep(state);

        // Change values
        newState.isGameActive = true;
        newState.isGameAnimating = false;
        newState.startTime = new Date();
        newState.isEdgesActive = false;
        newState.isPreviewActive = false;

        // Return new state
        return newState;
      }
    case "TOGGLE_EDGES":
      {
        // Initial variables
        var _newState = _.cloneDeep(state);

        // Change state
        _newState.isEdgesActive = !_newState.isEdgesActive;

        // Return new state
        return _newState;
      }
    case "TOGGLE_PREVIEW":
      {
        // Initial variables
        var _newState2 = _.cloneDeep(state);

        // Change state
        _newState2.isPreviewActive = !_newState2.isPreviewActive;

        // Return new state
        return _newState2;
      }
    case "SUBTRACT_FROM_TIME":
      {
        // Initial variables
        var _newState3 = _.cloneDeep(state);

        // Change state
        _newState3.startTime = new Date(_newState3.startTime.getTime() + action.duration);

        // Return new state
        return _newState3;
      }
    case "START_ANIMATION":
      {
        // Initial variables
        var _newState4 = _.cloneDeep(state);

        // Change state
        _newState4.isGameAnimating = true;

        // Return new state
        return _newState4;
      }
    case "END_ANIMATION":
      {
        // Initial variables
        var _newState5 = _.cloneDeep(state);

        // Change state
        _newState5.isGameAnimating = false;

        // Return new state
        return _newState5;
      }
    default:
      return state;
  }
};

/* harmony default export */ var src_reducer = (reducer_reducer);
// CONCATENATED MODULE: ./src/store/createHelpers.js
function createHelpers(_ref) {
  var history = _ref.history;

  return {
    history: history
  };
}
// EXTERNAL MODULE: ./node_modules/redux-logger/dist/redux-logger.js
var redux_logger = __webpack_require__(577);
var redux_logger_default = /*#__PURE__*/__webpack_require__.n(redux_logger);

// CONCATENATED MODULE: ./src/store/logger/logger.client.js


function logger_client_createLogger() {
  return Object(redux_logger["createLogger"])({
    collapsed: true
  });
}
// CONCATENATED MODULE: ./src/store/configureStore.js






function configureStore(initialState, helpersConfig) {
  var helpers = createHelpers(helpersConfig);
  var middleware = [redux_thunk_es["a" /* default */].withExtraArgument(helpers)];

  var enhancer = void 0;

  if (false) {
    middleware.push(createLogger());

    // https://github.com/zalmoxisus/redux-devtools-extension#redux-devtools-extension
    var devToolsExtension = function devToolsExtension(f) {
      return f;
    };
    if (process.env.BROWSER && window.devToolsExtension) {
      devToolsExtension = window.devToolsExtension();
    }

    enhancer = compose(applyMiddleware.apply(undefined, middleware), devToolsExtension);
  } else {
    enhancer = redux_es["a" /* applyMiddleware */].apply(undefined, middleware);
  }

  // See https://github.com/rackt/redux/releases/tag/v3.1.0
  var store = Object(redux_es["c" /* createStore */])(src_reducer, initialState, enhancer);

  // Hot reload reducers (requires Webpack or Browserify HMR to be enabled)
  if (false) {
    module.hot.accept("reducer", function () {
      return (
        // eslint-disable-next-line global-require
        store.replaceReducer(require("reducer").default)
      );
    });
  }

  return store;
}
// EXTERNAL MODULE: ./src/utils/history.js
var utils_history = __webpack_require__(232);

// CONCATENATED MODULE: ./src/utils/DOM.js
function updateTag(tagName, keyName, keyValue, attrName, attrValue) {
  var node = document.head.querySelector(tagName + "[" + keyName + "=\"" + keyValue + "\"]");
  if (node && node.getAttribute(attrName) === attrValue) return;

  // Remove and create a new tag in order to make it work with bookmarks in Safari
  if (node) {
    node.parentNode.removeChild(node);
  }
  if (typeof attrValue === "string") {
    var nextNode = document.createElement(tagName);
    nextNode.setAttribute(keyName, keyValue);
    nextNode.setAttribute(attrName, attrValue);
    document.head.appendChild(nextNode);
  }
}

function updateMeta(name, content) {
  updateTag("meta", "name", name, "content", content);
}

function updateCustomMeta(property, content) {
  updateTag("meta", "property", property, "content", content);
}

function updateLink(rel, href) {
  updateTag("link", "rel", rel, "href", href);
}
// EXTERNAL MODULE: ./node_modules/universal-router/browser.js
var browser = __webpack_require__(586);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);

// EXTERNAL MODULE: ./src/utils/assetPath.js
var assetPath = __webpack_require__(153);

// CONCATENATED MODULE: ./src/routes/index.js
function routes__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/* eslint-disable global-require */


// The top-level (parent) route
var routes = {
  path: "/",

  // Keep in mind, routes are evaluated in order
  children: [{
    path: "/",
    load: function load() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 918));
    }
  }, {
    path: "/topics",
    load: function load() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 918));
    }
  }, {
    path: "/topics/:id",
    load: function load() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 918));
    }
  }, {
    path: "/puzzles/:id",
    load: function load() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 919));
    }
  }, {
    path: "/about",
    load: function load() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 920));
    }
  }, {
    path: "/faq",
    load: function load() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 921));
    }
  }, {
    path: "/contact",
    load: function load() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 922));
    }
  }, {
    path: "/error",
    load: function load() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 923));
    }
  },
  // Wildcard routes, e.g. { path: '*', ... } (must go last)
  {
    path: "*",
    load: function load() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 924));
    }
  }],

  action: function action(_ref) {
    var _this = this;

    var next = _ref.next;
    return routes__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var route;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return next();

            case 2:
              route = _context.sent;


              // Provide default values for title, description etc.
              route.title = "" + (route.title || "Play Free Online Jigsaw Puzzle Games");
              route.description = route.description || "Jigsaw Puzzle is a classic jigsaw game. Choose from over 500.000 stunning pictures. Choose a difficulty between 11 and 625 pieces. Play online or download for Windows™ or Mac™.";
              route.image = "https://online-jigsaw-puzzles.com" + (route.image || Object(assetPath["a" /* default */])("frontpage_desktop", "jpg"));
              route.url = "https://online-jigsaw-puzzles.com" + (route.pathname || "");

              return _context.abrupt("return", route);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
};

// The error page is available by permanent url for development mode
if (false) {
  routes.children.unshift({
    path: "/error",
    action: require("./error").default
  });
}

/* harmony default export */ var src_routes = (routes);
// CONCATENATED MODULE: ./src/utils/router.js



/* harmony default export */ var router = (new browser_default.a(src_routes, {
  resolveRoute: function resolveRoute(context, params) {
    if (typeof context.route.load === "function") {
      return context.route.load().then(function (action) {
        return action.default(context, params);
      });
    }
    if (typeof context.route.action === "function") {
      return context.route.action(context, params);
    }
    return null;
  }
}));
// CONCATENATED MODULE: ./src/client.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var client__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Re-render the app when window.location changes
var onLocationChange = function () {
  var _ref = client__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(location, action) {
    var route;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // Remember the latest scroll position for the previous location
            scrollPositionsHistory[currentLocation.key] = {
              scrollX: window.pageXOffset,
              scrollY: window.pageYOffset
            };

            // Delete stored scroll position for next page if any
            if (action === "PUSH") {
              delete scrollPositionsHistory[location.key];
            }
            currentLocation = location;

            _context.prev = 3;

            context.pathname = location.pathname;
            context.query = query_string_default.a.parse(location.search);

            // Traverses the list of routes in the order they are defined until
            // it finds the first route that matches provided URL path string
            // and whose action method returns anything other than `undefined`.
            _context.next = 8;
            return router.resolve(client__extends({}, context, {
              path: location.pathname,
              query: query_string_default.a.parse(location.search)
            }));

          case 8:
            route = _context.sent;

            if (!(currentLocation.key !== location.key)) {
              _context.next = 11;
              break;
            }

            return _context.abrupt("return");

          case 11:
            if (!route.redirect) {
              _context.next = 14;
              break;
            }

            utils_history["a" /* default */].replace(route.redirect);
            return _context.abrupt("return");

          case 14:

            appInstance = react_dom_default.a.render(_jsx(components_App, {
              context: context
            }, void 0, route.component), container, function () {
              return onRenderComplete(route, location);
            });
            _context.next = 23;
            break;

          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](3);

            if (true) {
              _context.next = 21;
              break;
            }

            throw _context.t0;

          case 21:

            console.error(_context.t0);

            // Do a full page reload if error occurs during client-side navigation
            if (action && currentLocation.key === location.key) {
              window.location.reload();
            }

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[3, 17]]);
  }));

  return function onLocationChange(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

// Handle client-side navigation by using HTML5 History API
// For more information visit https://github.com/mjackson/history#readme


function client__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }






























__webpack_require__(718)($);

// -----------------------------------------------------------------------------
// Import globally available variables
// -----------------------------------------------------------------------------
// Set main domain for cross origin reasons
document.domain = window.location.hostname;

// Setup Sentry
window.Raven = singleton_default.a;
window.Raven.config("https://f22227374ade4cb49a081665ca90a4dd@sentry.io/1303413").install();

// Setup event emitter
window.emitter = Object(mitt_es["a" /* default */])();

// Require lodash
window._ = lodash_default.a;

// Setup IsJS
window.is = is_default.a;

// Setup bowser
window.bowser = bowser_default.a;

window.device = es["a" /* default */];
window.parser = new ua_parser_default.a(window.navigator.userAgent);

// Initialize breakpoint
bootstrap_breakpoints_default.a.init({
  xs: { min: 0, max: 575 },
  sm: { min: 576, max: 885 },
  md: { min: 886, max: 1199 },
  lg: { min: 1200, max: 1363 },
  xl: { min: 1364, max: Infinity }
});
window.Breakpoint = bootstrap_breakpoints_default.a;

// Listen for height change
var windowResizeTimer = void 0;
window.addEventListener("resize", function () {
  // Reset window resize timer
  if (is.existy(windowResizeTimer)) {
    clearTimeout(windowResizeTimer);
  }

  // Call window resize change
  windowResizeTimer = _.delay(function () {
    // Emit event
    emitter.emit("windowResizeEvent");
  }, 320);
});

// Setup query
window.queryParameters = Object(misc["b" /* getParams */])(window.location.search);

// Set game
window.game = "jigsaw";

// Send message to renderer if desktop app
// Listen for Electron action taps
if (Object(misc["c" /* isDesktopApp */])() && is.existy(window.electron)) {
  var query = window._.reduce(window._.omit(window.queryParameters, ["platform", "version", "purchase_id"]), function (result, value, key) {
    if (result == "") {
      result += key + "=" + value;
    } else {
      result += "&" + key + "=" + value;
    }
    return result;
  }, "");
  var path = window.location.pathname + "?" + query;
  window.electron.sendMessageFromWebviewToRenderer({
    action: "last_path_loaded",
    value: path
  });
}

// Setup Mixpanel
window.mixpanel = mixpanel_cjs_default.a;
window.mixpanel.init("f1ec6ab319bc48134daf31f7e070c3d1");
window.mixpanel.register({
  platform: document.body.dataset.platform,
  game_version: document.body.dataset.version,
  game: document.body.dataset.game,
  source: document.body.dataset.source
});

// Setup Firebase
window.firebase = index_esm["default"];
window.firebase.initializeApp({
  apiKey: "AIzaSyAN4wJagvddtahSqjtjPNokVqugYQLQL2I",
  authDomain: "jigsaw-puzzle-ff8eb.firebaseapp.com",
  databaseURL: "https://jigsaw-puzzle-ff8eb.firebaseio.com",
  projectId: "jigsaw-puzzle-ff8eb",
  storageBucket: "jigsaw-puzzle-ff8eb.appspot.com",
  messagingSenderId: "184963400284"
});

// Listen for auth state
window.firebase.auth().onAuthStateChanged(function (firebaseUser) {
  // Sign user in anonymously
  if (window.is.not.existy(firebaseUser)) {
    window.firebase.auth().signInAnonymously();
  } else {
    window.firebase.database().ref(".info/connected").on('value', function (snapshot) {
      if (snapshot.val()) {
        window.firebase.database().ref("users/" + firebaseUser.uid + "/jigsaws_played_available_force").onDisconnect().set(true);
      }
    });
  }
});

// Load gamedistribution code
if (Object(misc["e" /* isGamedistributionApp */])()) {
  window.gamedistributionLoaded = false;

  window["GD_OPTIONS"] = {
    "gameId": "4d1a4fc412a84cd6a3b1cc79c79f8200",
    "onEvent": function onEvent(event) {
      switch (event.name) {
        case "SDK_READY":
          window.gamedistributionLoaded = true;
          emitter.emit("gamedistributionLoaded");
          break;
        case "SDK_GAME_START":
          $("#score_container .left_menu, #board_container .card_component, .modal_wrapper").show();
          break;
        case "SDK_GAME_PAUSE":
          $("#score_container .left_menu, #board_container .card_component, .modal_wrapper").hide();
          break;
        case "SDK_GDPR_TRACKING":
          // this event is triggered when your user doesn't want to be tracked
          break;
        case "SDK_GDPR_TARGETING":
          // this event is triggered when your user doesn't want personalised targeting
          break;
      }
    }
  };
  (function (d, s, id) {
    var js,
        fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    js = d.createElement(s);
    js.id = id;
    js.src = 'https://html5.api.gamedistribution.com/main.min.js';
    fjs.parentNode.insertBefore(js, fjs);
  })(document, 'script', 'gamedistribution-jssdk');
}

// Setup sound
window.soundHash = {};
soundmanager2["soundManager"].setup({
  debugMode: false,
  onready: function onready() {
    window.soundHash.invalid = soundmanager2["soundManager"].createSound({
      url: Object(assetPath["a" /* default */])("invalid", "mp3"),
      autoLoad: true,
      autoPlay: false
    });
    window.soundHash.plop = soundmanager2["soundManager"].createSound({
      url: Object(assetPath["a" /* default */])("plop", "mp3"),
      autoLoad: true,
      autoPlay: false
    });
  },
  defaultOptions: {
    volume: 100,
    useHighPerformance: true
  }
});

// Setup notifications
var setupNotifyDefaultsTimer = void 0;
var client_setupNotifyDefaults = function setupNotifyDefaults() {
  if (is.existy($.notifyDefaults)) {
    // Set basic values
    var offset = 16;
    var spacing = 8;

    // Change card size
    if (bootstrap_breakpoints_default.a.is("xs") || bootstrap_breakpoints_default.a.is("sm")) {
      offset = 12;
      spacing = 6;
    } else if (bootstrap_breakpoints_default.a.is("xl") && is.above($(window).height(), 850)) {
      offset = 24;
      spacing = 12;
    }

    // Extra offset if desktop
    if (Object(misc["c" /* isDesktopApp */])()) {
      offset += 20;
    }

    // Setup defaults
    $.notifyDefaults({
      element: "body",
      position: "fixed",
      type: "info",
      allow_dismiss: false,
      newest_on_top: true,
      placement: {
        from: "top",
        align: "center"
      },
      offset: offset,
      spacing: spacing,
      z_index: 400000,
      delay: 3200,
      timer: 400,
      mouse_over: "pause",
      animate: {
        enter: "animated slideInDown",
        exit: "animated slideOutUp"
      },
      template: '<div data-notify="container" class="col-10 col-sm-6 alert alert-{0}" role="alert">' + '<button type="button" aria-hidden="true" class="close" data-notify="dismiss">×</button>' + '<span data-notify="icon"></span> ' + '<span data-notify="title">{1}</span> ' + '<span data-notify="message">{2}</span>' + '<div class="progress" data-notify="progressbar">' + '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' + "</div>" + '<a href="{3}" target="{4}" data-notify="url"></a>' + "</div>"
    });
    clearTimeout(setupNotifyDefaultsTimer);
  }
};
setupNotifyDefaultsTimer = setInterval(client_setupNotifyDefaults, 320);
client_setupNotifyDefaults();

/* eslint-disable window-require */

// window (context) variables that can be easily accessed from any React component
// https://facebook.github.io/react/docs/context.html
var context = {
  // Enables critical path CSS rendering
  // https://github.com/kriasoft/isomorphic-style-loader
  insertCss: function insertCss() {
    for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
      styles[_key] = arguments[_key];
    }

    // eslint-disable-next-line no-underscore-dangle
    var removeCss = styles.map(function (x) {
      return x._insertCss();
    });
    return function () {
      removeCss.forEach(function (f) {
        return f();
      });
    };
  },
  // Initialize a new Redux store
  // http://redux.js.org/docs/basics/UsageWithReact.html
  store: configureStore(window.App.state, { history: utils_history["a" /* default */] }),
  // Universal HTTP client
  fetch: utils_createFetch(fetch, {
    baseUrl: window.App.apiUrl
  })
};

// Switch off the native scroll restoration behavior and handle it manually
// https://developers.google.com/web/updates/2015/09/history-api-scroll-restoration
var scrollPositionsHistory = {};
if (window.history && "scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

var onRenderComplete = function initialRenderComplete() {
  var elem = document.getElementById("css");
  if (elem) elem.parentNode.removeChild(elem);
  onRenderComplete = function renderComplete(route, location) {
    document.title = route.title;

    updateMeta("description", route.description);
    // Update necessary tags in <head> at runtime here, ie:
    // updateMeta('keywords', route.keywords);
    // updateCustomMeta('og:url', route.canonicalUrl);
    // updateCustomMeta('og:image', route.imageUrl);
    // updateLink('canonical', route.canonicalUrl);
    // etc.

    var scrollX = 0;
    var scrollY = 0;
    var pos = scrollPositionsHistory[location.key];
    if (pos) {
      scrollX = pos.scrollX;
      scrollY = pos.scrollY;
    } else {
      var targetHash = location.hash.substr(1);
      if (targetHash) {
        var target = document.getElementById(targetHash);
        if (target) {
          scrollY = window.pageYOffset + target.getBoundingClientRect().top;
        }
      }
    }

    // Restore the scroll position if it was saved into the state
    // or scroll to the given #hash anchor
    // or scroll to top of the page
    window.scrollTo(scrollX, scrollY);
  };
};

var container = document.getElementById("app");
var appInstance = void 0;
var currentLocation = utils_history["a" /* default */].location;utils_history["a" /* default */].listen(onLocationChange);
onLocationChange(currentLocation);

// Enable Hot Module Replacement (HMR)
if (false) {
  module.hot.accept("./utils/router", function () {
    if (appInstance) {
      // Force-update the whole tree, including components that refuse to update
      deepForceUpdate(appInstance);
    }

    onLocationChange(currentLocation);
  });
}

/***/ }),

/***/ 590:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./about@1x.png": 591,
	"./about@2x.png": 592,
	"./about@3x.png": 593,
	"./arrow_down@1x.png": 594,
	"./arrow_down@2x.png": 595,
	"./arrow_down@3x.png": 596,
	"./back@1x.png": 597,
	"./back@2x.png": 598,
	"./back@3x.png": 599,
	"./background_overlay@1x.png": 600,
	"./background_overlay@2x.png": 601,
	"./background_overlay@3x.png": 602,
	"./background_tile@1x.jpg": 603,
	"./background_tile@2x.jpg": 604,
	"./background_tile@3x.jpg": 605,
	"./bookmark@1x.png": 606,
	"./bookmark@2x.png": 607,
	"./bookmark@3x.png": 608,
	"./close@1x.png": 609,
	"./close@2x.png": 610,
	"./close@3x.png": 611,
	"./download@1x.png": 612,
	"./download@2x.png": 613,
	"./download@3x.png": 614,
	"./edges@1x.png": 615,
	"./edges@2x.png": 616,
	"./edges@3x.png": 617,
	"./edges_grey@1x.png": 618,
	"./edges_grey@2x.png": 619,
	"./edges_grey@3x.png": 620,
	"./facebook@1x.png": 621,
	"./facebook@2x.png": 622,
	"./facebook@3x.png": 623,
	"./frontpage@1x.png": 624,
	"./frontpage@2x.png": 625,
	"./frontpage@3x.png": 626,
	"./frontpage_autoplay@1x.png": 627,
	"./frontpage_autoplay@2x.png": 628,
	"./frontpage_autoplay@3x.png": 629,
	"./frontpage_design@1x.png": 630,
	"./frontpage_design@2x.png": 631,
	"./frontpage_design@3x.png": 632,
	"./frontpage_desktop@1x.jpg": 633,
	"./frontpage_desktop@2x.jpg": 634,
	"./frontpage_desktop@3x.jpg": 635,
	"./frontpage_download@1x.png": 636,
	"./frontpage_download@2x.png": 637,
	"./frontpage_download@3x.png": 638,
	"./frontpage_eye@1x.png": 639,
	"./frontpage_eye@2x.png": 640,
	"./frontpage_eye@3x.png": 641,
	"./frontpage_hint@1x.png": 642,
	"./frontpage_hint@2x.png": 643,
	"./frontpage_hint@3x.png": 644,
	"./frontpage_hotkeys@1x.png": 645,
	"./frontpage_hotkeys@2x.png": 646,
	"./frontpage_hotkeys@3x.png": 647,
	"./frontpage_icon@1x.png": 648,
	"./frontpage_icon@2x.png": 649,
	"./frontpage_icon@3x.png": 650,
	"./frontpage_infinite@1x.png": 651,
	"./frontpage_infinite@2x.png": 652,
	"./frontpage_infinite@3x.png": 653,
	"./frontpage_mobile@1x.jpg": 654,
	"./frontpage_mobile@2x.jpg": 655,
	"./frontpage_mobile@3x.jpg": 656,
	"./frontpage_settings@1x.png": 657,
	"./frontpage_settings@2x.png": 658,
	"./frontpage_settings@3x.png": 659,
	"./frontpage_sizes@1x.png": 660,
	"./frontpage_sizes@2x.png": 661,
	"./frontpage_sizes@3x.png": 662,
	"./frontpage_stars@1x.png": 663,
	"./frontpage_stars@2x.png": 664,
	"./frontpage_stars@3x.png": 665,
	"./frontpage_undo@1x.png": 666,
	"./frontpage_undo@2x.png": 667,
	"./frontpage_undo@3x.png": 668,
	"./hint@1x.png": 669,
	"./hint@2x.png": 670,
	"./hint@3x.png": 671,
	"./info@1x.png": 672,
	"./info@2x.png": 673,
	"./info@3x.png": 674,
	"./play@1x.png": 675,
	"./play@2x.png": 237,
	"./play@3x.png": 676,
	"./play_large@1x.png": 677,
	"./play_large@2x.png": 678,
	"./play_large@3x.png": 679,
	"./preview@1x.png": 680,
	"./preview@2x.png": 681,
	"./preview@3x.png": 682,
	"./preview_grey@1x.png": 683,
	"./preview_grey@2x.png": 684,
	"./preview_grey@3x.png": 685,
	"./preview_large@1x.png": 686,
	"./preview_large@2x.png": 687,
	"./preview_large@3x.png": 688,
	"./purchase_hero@1x.jpg": 689,
	"./purchase_hero@2x.jpg": 690,
	"./purchase_hero@3x.jpg": 691,
	"./sale_sticker@1x.png": 692,
	"./sale_sticker@2x.png": 693,
	"./sale_sticker@3x.png": 694,
	"./search@1x.png": 695,
	"./search@2x.png": 696,
	"./search@3x.png": 697,
	"./settings@1x.png": 698,
	"./settings@2x.png": 699,
	"./settings@3x.png": 700,
	"./shuffle@1x.png": 701,
	"./shuffle@2x.png": 702,
	"./shuffle@3x.png": 703,
	"./shuffle_grey@1x.png": 704,
	"./shuffle_grey@2x.png": 705,
	"./shuffle_grey@3x.png": 706,
	"./statistics@1x.png": 707,
	"./statistics@2x.png": 708,
	"./statistics@3x.png": 709,
	"./twitter@1x.png": 710,
	"./twitter@2x.png": 711,
	"./twitter@3x.png": 712
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 590;

/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/about@1x.png?f22dfbe0";

/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/about@2x.png?e71ee693";

/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/about@3x.png?f4fd4c7a";

/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/arrow_down@1x.png?d3a72506";

/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/arrow_down@2x.png?8723d86d";

/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/arrow_down@3x.png?53bee69f";

/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/back@1x.png?098f14e9";

/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/back@2x.png?58c8bc1e";

/***/ }),

/***/ 599:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/back@3x.png?9d21a342";

/***/ }),

/***/ 600:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/background_overlay@1x.png?d1589aa5";

/***/ }),

/***/ 601:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/background_overlay@2x.png?de94db91";

/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/background_overlay@3x.png?e9080fef";

/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/background_tile@1x.jpg?89f004f0";

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/background_tile@2x.jpg?4308c0d6";

/***/ }),

/***/ 605:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/background_tile@3x.jpg?fcd8b22e";

/***/ }),

/***/ 606:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/bookmark@1x.png?cbd2b74e";

/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/bookmark@2x.png?f6b337e9";

/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/bookmark@3x.png?67845a63";

/***/ }),

/***/ 609:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/close@1x.png?692a6646";

/***/ }),

/***/ 610:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/close@2x.png?5146dab2";

/***/ }),

/***/ 611:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/close@3x.png?757d2662";

/***/ }),

/***/ 612:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/download@1x.png?09ce5e15";

/***/ }),

/***/ 613:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/download@2x.png?2a90a8d8";

/***/ }),

/***/ 614:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/download@3x.png?c4fadc3f";

/***/ }),

/***/ 615:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/edges@1x.png?67430fca";

/***/ }),

/***/ 616:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/edges@2x.png?91aa42c6";

/***/ }),

/***/ 617:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/edges@3x.png?7003f288";

/***/ }),

/***/ 618:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/edges_grey@1x.png?47380848";

/***/ }),

/***/ 619:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/edges_grey@2x.png?ebc85c7d";

/***/ }),

/***/ 620:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/edges_grey@3x.png?b818d1aa";

/***/ }),

/***/ 621:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/facebook@1x.png?8957ba69";

/***/ }),

/***/ 622:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/facebook@2x.png?6299aebc";

/***/ }),

/***/ 623:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/facebook@3x.png?14ff083d";

/***/ }),

/***/ 624:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage@1x.png?4da97d54";

/***/ }),

/***/ 625:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage@2x.png?55823a7b";

/***/ }),

/***/ 626:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage@3x.png?9472c34d";

/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_autoplay@1x.png?e09fcdcf";

/***/ }),

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_autoplay@2x.png?0d576fe9";

/***/ }),

/***/ 629:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_autoplay@3x.png?ff845b3d";

/***/ }),

/***/ 630:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_design@1x.png?20b9aadb";

/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_design@2x.png?01cb8c58";

/***/ }),

/***/ 632:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_design@3x.png?732324c5";

/***/ }),

/***/ 633:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_desktop@1x.jpg?ca7dc622";

/***/ }),

/***/ 634:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_desktop@2x.jpg?30084b96";

/***/ }),

/***/ 635:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_desktop@3x.jpg?333733d2";

/***/ }),

/***/ 636:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_download@1x.png?8afa7ecb";

/***/ }),

/***/ 637:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_download@2x.png?60afe63e";

/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_download@3x.png?9713542b";

/***/ }),

/***/ 639:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_eye@1x.png?e55af9bc";

/***/ }),

/***/ 640:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_eye@2x.png?55a6c5e9";

/***/ }),

/***/ 641:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_eye@3x.png?6d28b979";

/***/ }),

/***/ 642:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_hint@1x.png?bf60b0de";

/***/ }),

/***/ 643:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_hint@2x.png?8447aa8b";

/***/ }),

/***/ 644:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_hint@3x.png?1e04c62c";

/***/ }),

/***/ 645:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_hotkeys@1x.png?7eeb4ab4";

/***/ }),

/***/ 646:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_hotkeys@2x.png?8ea4117c";

/***/ }),

/***/ 647:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_hotkeys@3x.png?3b73165b";

/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_icon@1x.png?12f24471";

/***/ }),

/***/ 649:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_icon@2x.png?95822b75";

/***/ }),

/***/ 650:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_icon@3x.png?790b5e0c";

/***/ }),

/***/ 651:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_infinite@1x.png?30326aa4";

/***/ }),

/***/ 652:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_infinite@2x.png?4fbf706e";

/***/ }),

/***/ 653:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_infinite@3x.png?9f8b78fc";

/***/ }),

/***/ 654:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_mobile@1x.jpg?f1d56899";

/***/ }),

/***/ 655:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_mobile@2x.jpg?9923b2dc";

/***/ }),

/***/ 656:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_mobile@3x.jpg?93f45c24";

/***/ }),

/***/ 657:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_settings@1x.png?cf9bc403";

/***/ }),

/***/ 658:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_settings@2x.png?cc07563b";

/***/ }),

/***/ 659:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_settings@3x.png?27c90a2f";

/***/ }),

/***/ 660:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_sizes@1x.png?08f57ad1";

/***/ }),

/***/ 661:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_sizes@2x.png?86dad90c";

/***/ }),

/***/ 662:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_sizes@3x.png?44ed6bfd";

/***/ }),

/***/ 663:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_stars@1x.png?cfc1ce92";

/***/ }),

/***/ 664:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_stars@2x.png?67139704";

/***/ }),

/***/ 665:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_stars@3x.png?d754c8f0";

/***/ }),

/***/ 666:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_undo@1x.png?53bd49b0";

/***/ }),

/***/ 667:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_undo@2x.png?50cc7593";

/***/ }),

/***/ 668:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/frontpage_undo@3x.png?6def7cb6";

/***/ }),

/***/ 669:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/hint@1x.png?3276b306";

/***/ }),

/***/ 670:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/hint@2x.png?ccf99cdd";

/***/ }),

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/hint@3x.png?992fafcb";

/***/ }),

/***/ 672:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/info@1x.png?84086234";

/***/ }),

/***/ 673:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/info@2x.png?87683048";

/***/ }),

/***/ 674:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/info@3x.png?86804022";

/***/ }),

/***/ 675:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/play@1x.png?7551d5dc";

/***/ }),

/***/ 676:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/play@3x.png?61a61d7f";

/***/ }),

/***/ 677:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/play_large@1x.png?250c10be";

/***/ }),

/***/ 678:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/play_large@2x.png?364b4b59";

/***/ }),

/***/ 679:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/play_large@3x.png?317f1002";

/***/ }),

/***/ 680:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/preview@1x.png?d0ddb85a";

/***/ }),

/***/ 681:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/preview@2x.png?3c461185";

/***/ }),

/***/ 682:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/preview@3x.png?b65a810b";

/***/ }),

/***/ 683:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/preview_grey@1x.png?0c4f464f";

/***/ }),

/***/ 684:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/preview_grey@2x.png?a7b87b3e";

/***/ }),

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/preview_grey@3x.png?21e273b0";

/***/ }),

/***/ 686:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/preview_large@1x.png?d53721a8";

/***/ }),

/***/ 687:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/preview_large@2x.png?dc7655ed";

/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/preview_large@3x.png?44b41528";

/***/ }),

/***/ 689:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/purchase_hero@1x.jpg?d7cb9083";

/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/purchase_hero@2x.jpg?a0eafb63";

/***/ }),

/***/ 691:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/purchase_hero@3x.jpg?6160227e";

/***/ }),

/***/ 692:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/sale_sticker@1x.png?c82b62a1";

/***/ }),

/***/ 693:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/sale_sticker@2x.png?ecb04350";

/***/ }),

/***/ 694:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/sale_sticker@3x.png?d95f002e";

/***/ }),

/***/ 695:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/search@1x.png?b79b6629";

/***/ }),

/***/ 696:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/search@2x.png?d9e229b8";

/***/ }),

/***/ 697:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/search@3x.png?4c2dfdfb";

/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/settings@1x.png?5180164a";

/***/ }),

/***/ 699:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/settings@2x.png?cf8a97c9";

/***/ }),

/***/ 700:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/settings@3x.png?43491cca";

/***/ }),

/***/ 701:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/shuffle@1x.png?0fb28f58";

/***/ }),

/***/ 702:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/shuffle@2x.png?9d68ff71";

/***/ }),

/***/ 703:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/shuffle@3x.png?2e8343e5";

/***/ }),

/***/ 704:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/shuffle_grey@1x.png?25e54ade";

/***/ }),

/***/ 705:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/shuffle_grey@2x.png?5e93ac39";

/***/ }),

/***/ 706:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/shuffle_grey@3x.png?54019bd0";

/***/ }),

/***/ 707:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/statistics@1x.png?7f9a0564";

/***/ }),

/***/ 708:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/statistics@2x.png?89f9bc75";

/***/ }),

/***/ 709:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/statistics@3x.png?aed031cf";

/***/ }),

/***/ 710:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/twitter@1x.png?ce339d5d";

/***/ }),

/***/ 711:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/twitter@2x.png?35583212";

/***/ }),

/***/ 712:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/twitter@3x.png?45a3e0a4";

/***/ }),

/***/ 713:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./list_check.svg": 240,
	"./search.svg": 714,
	"./table_no.svg": 241,
	"./table_yes.svg": 238
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 713;

/***/ }),

/***/ 714:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/search.svg?fe7ee78a";

/***/ }),

/***/ 715:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./invalid.mp3": 716,
	"./plop.mp3": 717
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;

/***/ }),

/***/ 716:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sounds/invalid.mp3?af7d7194";

/***/ }),

/***/ 717:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sounds/plop.mp3?ea9c7820";

/***/ })

},[242]);


// WEBPACK FOOTER //
// client.2b984a81.js